import localStorageService from "./axios-service/localStorageService";
import Api from "./axios-service/apiInstance";
import { Authentication } from "./axios-service/authentication";
export default Api;
export { localStorageService, Authentication };
